import {IconProps} from './types';

function AiAgentPencilIcon({stroke = 'currentColor', width = 16, height = 16, className}: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            className={className}
            aria-hidden
        >
            <g clipPath="url(#aiAgentPencilClip)">
                <path
                    d="M4.64416 14.6553L0.333496 15.6666L1.34483 11.3566L11.9762 0.723967C12.1 0.600099 12.247 0.501838 12.4088 0.434798C12.5706 0.367758 12.744 0.333252 12.9192 0.333252C13.0943 0.333252 13.2677 0.367758 13.4295 0.434798C13.5913 0.501838 13.7383 0.600099 13.8622 0.723967L15.2768 2.13797C15.4007 2.26179 15.499 2.4088 15.566 2.5706C15.633 2.7324 15.6675 2.90583 15.6675 3.08097C15.6675 3.25611 15.633 3.42953 15.566 3.59134C15.499 3.75314 15.4007 3.90015 15.2768 4.02397L4.64416 14.6553Z"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.8069 4.49665L11.5049 1.19531"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8555 5.44794L10.5615 2.13794"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.81221 14.4887L1.51221 11.1887"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="aiAgentPencilClip">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default AiAgentPencilIcon;
